import { State } from '../StateTypes';

export const selectRangeData = (state: State) => state.rangeData;

export const selectRangeDataSlice = (key: string) => (state: State) =>
  selectRangeData(state)[key];
